import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signIn(email.trim().toLowerCase(), password);
      toast.success("Welcome back, Admin.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err, "Login failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative">
      <div className="absolute inset-0 bg-radial-glow pointer-events-none" />
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative glass-strong rounded-3xl p-8 md:p-10 w-full max-w-md"
      >
        <div className="flex items-center gap-3 mb-6">
          <span className="w-10 h-10 rounded-xl bg-[#00F0FF]/10 border border-[#00F0FF]/40 flex items-center justify-center">
            <Lock className="w-5 h-5 text-[#00F0FF]" />
          </span>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#00F0FF] font-bold">Reness AI</p>
            <h1 className="font-display text-2xl font-black text-white">Admin Sign-In</h1>
          </div>
        </div>

        <label className="text-xs uppercase tracking-wider text-zinc-400">Email</label>
        <input
          data-testid="admin-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-1 w-full bg-black/60 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF] outline-none transition"
          placeholder="admin@reness.ai"
          autoComplete="username"
        />

        <label className="text-xs uppercase tracking-wider text-zinc-400 mt-4 block">Password</label>
        <input
          data-testid="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full bg-black/60 border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#00F0FF] focus:ring-1 focus:ring-[#00F0FF] outline-none transition"
          autoComplete="current-password"
        />

        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-6 w-full bg-[#00F0FF] text-black py-3 rounded-xl font-bold hover:bg-[#33F3FF] transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" /> Signing in…
            </>
          ) : (
            "Sign In"
          )}
        </button>

        <p className="mt-4 text-[11px] tracking-[0.2em] uppercase text-zinc-500 text-center">
          5 failed attempts = 15-minute lockout
        </p>
      </form>
    </div>
  );
}
